var _style, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "matic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8247E5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.3,163.9c-9.2-5.4-21.2-5.4-31.4,0l-72,41.7l-48.9,27.2l-72,41.7c-9.2,5.4-21.2,5.4-31.4,0l-57.2-32.6 c-9.2-5.4-15.7-15.4-15.7-26.3v-64.3c0-10.9,5.5-20.8,15.7-26.3l56.3-31.7c9.2-5.4,21.2-5.4,31.4,0l56.3,31.7 c9.2,5.4,15.7,15.4,15.7,26.3v41.7l48.9-28.1v-41.7c0-10.9-5.5-20.8-15.7-26.3L153.1,37.1c-9.2-5.4-21.2-5.4-31.4,0L15.7,96.9 C5.5,102.3,0,112.3,0,123.2v120.5c0,10.9,5.5,20.8,15.7,26.3l106.1,59.8c9.2,5.4,21.2,5.4,31.4,0l72-40.8l48.9-28.1l72-40.8 c9.2-5.4,21.2-5.4,31.4,0l56.3,31.7c9.2,5.4,15.7,15.4,15.7,26.3v64.3c0,10.9-5.5,20.8-15.7,26.3l-56.3,32.6 c-9.2,5.4-21.2,5.4-31.4,0l-56.3-31.7c-9.2-5.4-15.7-15.4-15.7-26.3v-41.7l-48.9,28.1v41.7c0,10.9,5.5,20.8,15.7,26.3l106.1,59.8 c9.2,5.4,21.2,5.4,31.4,0l106.1-59.8c9.2-5.4,15.7-15.4,15.7-26.3V250.9c0-10.9-5.5-20.8-15.7-26.3L377.3,163.9z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/matic.d470a895d43ef5bb4e9a6120bb4c0b63.svg";
export { ForwardRef as ReactComponent };